import Vue from 'vue'
import Vuex from 'vuex'
import VuexPersistence from 'vuex-persist'
import GeneralStore from '@/stores/generalStore.js'
import UserStore from '@/stores/userStore.js'
import ForecastingStore from '@/stores/forecastingStore.js'
import AlertStore from '@/stores/alertStore.js'
import ConfigurationStore from '@/stores/configurationStore.js'
import SprayStore from '@/stores/sprayStore.js'
import ScoutStore from '@/stores/scoutStore.js'
import PlantStore from '@/stores/plantStore.js'
import RosterStore from '@/stores/rosterStore.js'
import PersonnelMovementsStore from '@/stores/personnelMovementsStore.js'
import PrecedaStore from '@/stores/precedaStore.js'
import DataImportStore from '@/stores/dataImportStore.js'
import TrapInspectionStore from '@/stores/trapInspectionStore.js'
import PestAndDiseaseStore from '@/stores/pestAndDiseaseStore.js'
import ForecastingProfileStore from '@/stores/forecastingProfileStore.js'
import CropStore from '@/stores/cropStore.js'
import CropWorkStore from '@/stores/cropWorkStore.js'
import HarvestPlanStore from '@/stores/harvestPlanStore.js'
import RejectionStore from '@/stores/rejectionStore.js'
import NuPointSprayStore from '@/stores/nuPointSprayStore.js'

Vue.use(Vuex)

/**
 * Any modules listed here will have their store state persisted.
 *
 * Anything persisted will keep the store the same across page reloads.
 *
 * Anything not persisted will reset to its default values when the browser
 * reloads the page. Using the Vue internal router for page navigation does
 * *not* reload the page in the browser, and therefore the store will not
 * be reset when we do this. Things that will reset the state for anything
 * not persisted:
 * - window.location.href
 * - user entering URL in browser and navigating manually
 * - browser refresh button
 *
 * We are only persisting the User store, for example, so that when
 * a user reloads a page it doesn't get reset
 *
 * See https://github.com/championswimmer/vuex-persist for more options
**/
const vuexLocal = new VuexPersistence({
  storage: window.localStorage, // where to persist the data (localStorage, sessionStorage, etc)
  modules: ['UserStore'] // which modules will have their store state persisted
});

export default new Vuex.Store({
  plugins: [
    vuexLocal.plugin
  ],
  modules: {
    GeneralStore,
    UserStore,
    ForecastingStore,
    AlertStore,
    ConfigurationStore,
    SprayStore,
    ScoutStore,
    PlantStore,
    PersonnelMovementsStore,
    PrecedaStore,
    DataImportStore,
    TrapInspectionStore,
    PestAndDiseaseStore,
    ForecastingProfileStore,
    CropStore,
    CropWorkStore,
    RosterStore,
    HarvestPlanStore,
    RejectionStore,
    NuPointSprayStore
  }
})
